<template>
  <div class="streaming_box">
    <div id="container" class="ccontainer"></div>
  </div>
</template>
<script>
import UEapi from '../utils/UEapi/UEapi'
import cameraList from '../utils/configs/cameraList'
export default {
  components: {},
  data() {
    return {
      cameraList: cameraList,
    }
  },
  methods: {
    init() {
      this.$store.commit('setLoading', true)
      UEapi.Common.initAVW()
    },

    panelClickFn() {
      window.addEventListener('closePanel', (e) => {
        window.appInstance.uniCall('removeOverlayTip', {
          overlayType: e.detail.layerType,
          id: e.detail.id,
        })
      })
    },
  },
  computed: {},
  mounted() {
    this.init()
    this.panelClickFn()
  },
  destroyed() {
    window.appInstance.uniCall('destroy')
  },
}
</script>
<style lang="less" scoped>
.streaming_box {
  width: 100%;
  height: 100%;
}
#container {
  width: 100%;
  height: 100%;
}
</style>
